// extracted by mini-css-extract-plugin
export default {"contents":"pG-z","sectionHeading":"qG-z"};